export default function Error() {

    return (
        <div>
            Errore fatale
        </div>
    );
}